const mergeArrayWithDefaults = (defaults, arr) => {
  const mergedObject = arr.reduce((acc, curr) => {
    const { type, ...rest } = curr;
    return {
      ...acc,
      [type]: rest,
    };
  }, defaults);
  return Object.keys(mergedObject).map(key => {
    return {
      type: key,
      ...mergedObject[key],
    };
  });
};

export const fillableDefaults = {
  phone: {
    number: '',
    extension: '',
  },
  address: {
    addressLine1: '',
    addressLine2: '',
    city: '',
    countryCode: 'UNITED STATES',
    county: null,
    stateCode: '',
    postalCode: '',
  },
};

export const fillWithDefaults = ({
  containingObject,
  fillType = {},
  propName = '',
  typeList = [],
}) => {
  if (!containingObject || typeof containingObject !== 'object') {
    // eslint-disable-next-line no-console
    return console.error(
      'WARN: defaultDataHelper.fillAddress: containingObject must be an object and cannot be undefined or null'
    );
  }

  const defaultValue = typeof fillType === 'object'
    ? fillType
    : fillableDefaults[fillType] || {};
  const defaultList = typeList.reduce((acc, curr) => {
    return {
      ...acc,
      [curr]: defaultValue,
    };
  }, {});

  const originalList = containingObject[propName] || [];

  return {
    ...containingObject,
    [propName]: mergeArrayWithDefaults(defaultList, originalList),
  };
};



// WEBPACK FOOTER //
// ./src/App/account/utils/defaultDataHelper.js